import React from 'react'
import formConfig from "../../../formJsonData/Purchase/BranchMaster/BranchList.json"
import Forms from '../../../components/common/Form';
import searchConfigJson from "../../../formJsonData/LMS/searchFilterFields.json"
const BranchList = () => {
  return (
    <div>
      <Forms formConfig={formConfig} searchConfigJson={searchConfigJson.branchmasterList}/>
    </div>
  )
}

export default BranchList
